import { render } from "./PaasListStatusAlerts.vue?vue&type=template&id=0c173bb2&scoped=true"
import script from "./PaasListStatusAlerts.vue?vue&type=script&lang=js"
export * from "./PaasListStatusAlerts.vue?vue&type=script&lang=js"

import "./PaasListStatusAlerts.vue?vue&type=style&index=0&id=0c173bb2&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c173bb2"]])

export default __exports__